import Vue from "vue";
import Router from "vue-router";

// 解决 vue-router.esm.js Uncaught (in promise)
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);

const Home = () => import(/* webpackChunkName: "home" */ '@/pages/home/index');
const allModule = () => import(/* webpackChunkName: "home" */ '@/pages/home/allModule');
const editAllModule = () => import(/* webpackChunkName: "home" */ '@/pages/home/editAllModule');
const ProjectIntroduction = () => import(/* webpackChunkName: "home" */ '@/pages/home/projectIntroduction');
const parkMemberList = () => import(/* webpackChunkName: "home" */ '@/pages/home/parkMemberList');
const Activity = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/index');
const ActivityDetails = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/details');
const ActivityForm = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/form');
const ActivityOrderInfo = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/OrderInfo');
const ActivitySuccess = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/success');
const CompanyDetail = () => import(/* webpackChunkName: "activity" */ '@/pages/activity/companyDetail');
const Me = () => import(/* webpackChunkName: "me" */ '@/pages/me/index');
const News = () => import(/* webpackChunkName: "me" */ '@/pages/me/news');
const Setting = () => import(/* webpackChunkName: "me" */ '@/pages/me/setting');
const EditName = () => import(/* webpackChunkName: "me" */ '@/pages/me/editName');
const noticeList = () => import(/* webpackChunkName: "notice" */ '@/pages/notice/noticeList');
const noticeDetail = () => import(/* webpackChunkName: "notice" */ '@/pages/notice/noticeDetail');
const noticeFrom = () => import(/* webpackChunkName: "notice" */ '@/pages/notice/noticeFrom');
const ApprovalList = () => import(/* webpackChunkName: "approval" */ '@/pages/approval/approvalList');
const ApprovalDetail = () => import(/* webpackChunkName: "approval" */ '@/pages/approval/approvalDetail');
const VisitorReservationDetail = () => import(/* webpackChunkName: "approval" */ '@/pages/approval/VisitorReservationDetail');
const MeetingApproval = () => import(/* webpackChunkName: "approval" */ '@/pages/approval/meetingApproval');
const OfficeApproval = () => import(/* webpackChunkName: "approval" */ '@/pages/approval/officeApproval');
const Bill = () => import(/* webpackChunkName: "onlineBill" */ '@/pages/onlineBill/bill');
const BillDetail = () => import(/* webpackChunkName: "onlineBill" */ '@/pages/onlineBill/billDetail');
const BillHistory = () => import(/* webpackChunkName: "onlineBill" */ '@/pages/onlineBill/billHistory');
const RevenueIndex = () => import(/* webpackChunkName: "RevenueReporting" */ '@/pages/RevenueReporting/index');
const RevenueForm = () => import(/* webpackChunkName: "RevenueReporting" */ '@/pages/RevenueReporting/form');
const MyOrder = () => import(/* webpackChunkName: "myOrder" */ '@/pages/myOrder');
const MyActivityOrder = () => import(/* webpackChunkName: "myOrder" */ '@/pages/myOrder/activityOrderDetail');
const MyMeetingOrder = () => import(/* webpackChunkName: "myOrder" */ '@/pages/myOrder/meetingOrderDetail');
//会议室开票
const InvoiceFrom = () =>import(/* webpackChunkName: "meetingRoom" */ "@/pages/myOrder/invoiceFrom");
const MyOfficeOrder = () => import(/* webpackChunkName: "myOrder" */ '@/pages/myOrder/officeOrderDetail');
const MyOfficeWxOrder = () => import(/* webpackChunkName: "myOrder" */ '@/pages/myOrder/officeOrderWxDetail');
const Login = () => import(/* webpackChunkName: "login" */ '@/pages/login');
const About = () => import(/* webpackChunkName: "about" */ '@/pages/about');
const SuccessPage = () => import(/* webpackChunkName: "success" */ '@/pages/successPage');
const AgreeMent = () => import(/* webpackChunkName: "about" */ '@/pages/agreeMent');
const CompanyList = () => import(/* webpackChunkName: "myCompany" */ '@/pages/myCompany/index');
const AddCompany = () => import(/* webpackChunkName: "myCompany" */ '@/pages/myCompany/addCompany');
const CompanySelect = () => import(/* webpackChunkName: "myCompany" */ '@/pages/myCompany/companySelect');
const AddPhoto = () => import(/* webpackChunkName: "myCompany" */ '@/pages/myCompany/addPhoto');
const ShotPhoto = () => import(/* webpackChunkName: "myCompany" */ '@/pages/myCompany/shotPhoto');
const Fanke = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/index');
const searchPerson = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/searchPerson');
const searchCompany = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/searchCompany');
const VisitAccessCard = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/visitAccessCard');
const VisitHistory = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/history/index');
const VisitDetails = () => import(/* webpackChunkName: "fanke" */ '@/pages/fanke/history/details');
const AccessControl = () => import(/* webpackChunkName: "fanke" */ '@/pages/accessControl/index');
//商业生活
const BusinessLife = () => import(/* webpackChunkName: "BusinessLife" */ '@/pages/BusinessLife/list');
const BusinessDetail = () => import(/* webpackChunkName: "BusinessLife" */ '@/pages/BusinessLife/detail');
const BusinessSearch = () => import(/* webpackChunkName: "BusinessLife" */ '@/pages/BusinessLife/search');
// 会议室
const MeetingRoom = () => import(/* webpackChunkName: "meetingRoom" */ '@/pages/meetingRoom/index');
const RoomDetail = () => import(/* webpackChunkName: "meetingRoom" */ '@/pages/meetingRoom/roomDetail');
const RoomDate = () => import(/* webpackChunkName: "meetingRoom" */ '@/pages/meetingRoom/roomDate');
const YudingName = () => import(/* webpackChunkName: "meetingRoom" */ '@/pages/meetingRoom/yudingName');
const RoomPay = () => import(/* webpackChunkName: "meetingRoom" */ '@/pages/meetingRoom/roomPay');
// 电子发票
const InvoicIndex = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/index");
const InvoicingList = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/InvoicingList");
const invoiceHistory = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceHistory");
const invoiceDetail = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceDetail");
const invoiceInfo = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceInfo");
const invoiceDetailRepeat = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceDetailRepeat");
const invoiceFromPage = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceFrom");
const InvoicSuccess = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/InvoicSuccess");
const invoiceHelp = () =>import(/* webpackChunkName: "Invoicing" */ "@/pages/Invoicing/invoiceHelp");
// 水电充值
const hpRecharge = () =>
  import(/* webpackChunkName: "hydropower" */ "@/pages/hydropower/recharge"); //充值
const rechargeRecord = () =>
import(
    /* webpackChunkName: "hydropower" */ "@/pages/hydropower/rechargeRecord"
  ); //充值记录
const hpuseStatistics = () =>
    import(
      /* webpackChunkName: "hydropower" */ "@/pages/hydropower/useStatistics"
    ); //使用统计
const hpuseDetailed = () =>
      import(
        /* webpackChunkName: "hydropower" */ "@/pages/hydropower/useDetailed"
      ); //使用明细
//项目会议室水牌
const WaterMeetingIndex = () =>
  import(/* webpackChunkName: "WaterSign" */ "@/pages/WaterMeeting/index");
const WaterMeetingMian = () =>
  import(/* webpackChunkName: "WaterSign" */ "@/pages/WaterMeeting/mianView");
//公司会议室水牌
const WaterSignIndex = () => import(/* webpackChunkName: "WaterSign" */ '@/pages/WaterSign/index');
const WaterSignMian = () => import(/* webpackChunkName: "WaterSign" */ '@/pages/WaterSign/mianView');
//奋斗报告
const StruggleReport = () => import(/* webpackChunkName: "StruggleReport" */ '@/pages/smartOffice/StruggleReport/index');
const StruggleCalendar = () => import(/* webpackChunkName: "StruggleReport" */ '@/pages/smartOffice/StruggleReport/calendar');
const StruggleMonthlyReport = () => import(/* webpackChunkName: "StruggleReport" */ '@/pages/smartOffice/StruggleReport/monthlyReport');
const StruggleSignInList = () => import(/* webpackChunkName: "StruggleReport" */ '@/pages/smartOffice/StruggleReport/SignInList');
//能耗曲线
const EnergyConsumption = () =>import(/* webpackChunkName: "StruggleReport" */ "@/pages/smartOffice/energyConsumption/index");
//环境指数
const Environmental = () =>import(/* webpackChunkName: "StruggleReport" */ "@/pages/smartOffice/environmental/index");


const evaluate = () => import(/* webpackChunkName: "evaluate" */ '@/pages/myOrder/evaluate/index');
const evaluateSm = () => import(/* webpackChunkName: "evaluate" */ '@/pages/myOrder/evaluate/evaluateSm');
const evaluateSuccess = () => import(/* webpackChunkName: "evaluate" */ '@/pages/myOrder/evaluate/success');
const viewEvaluate = () => import(/* webpackChunkName: "evaluate" */ '@/pages/myOrder/evaluate/viewEvaluate');

const comReporting = () => import(/* webpackChunkName: "comReporting" */ '@/pages/comReporting/index');
const comReportingDetails = () => import(/* webpackChunkName: "comReporting" */ '@/pages/comReporting/details');
//物业报修
const WuyeRepair = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/index');
const SublimeSuccess = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/sublimeSuccess');
const MyRepairOrder = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/myRepairOrder');
const RepairOrderDetails = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/orderDetails');
const ViewVideo = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/viewVideo');
const ViewImage = () => import(/* webpackChunkName: "wuyeRepair" */ '@/pages/wuyeRepair/viewImage');
// 空铺招租
const EmptyShopList = () => import(/* webpackChunkName: "emptyShop" */ '@/pages/emptyShop/index');
const EmptyShopDetail = () => import(/* webpackChunkName: "emptyShop" */ '@/pages/emptyShop/detail');
// 政策服务
const policyServices = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/index');
const policySearch = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/search');
const policyDetail = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/detail');
const comsultationForm = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/comsultationForm');
const policyList = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/policyList');
const fileList = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/fileList');
const myConsultation = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/myConsultation');
const myConsultationDetail = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/myConsultationDetail');
const handleConsultation = () => import(/* webpackChunkName: "policyServices" */ '@/pages/policyServices/handleConsultation');
//投诉建议
const tsComplaint = () => import(/* webpackChunkName: "tsComplaint" */ '@/pages/tsComplaint/index');
const myComplaintOrder = () => import(/* webpackChunkName: "tsComplaint" */ '@/pages/tsComplaint/myComplaintOrder');
const repairComplaintDetails = () => import(/* webpackChunkName: "tsComplaint" */ '@/pages/tsComplaint/orderDetails');
//优惠券
const myCoupon = () => import(/* webpackChunkName: "Coupon" */ '@/pages/Coupon/myCoupon');
const couponDetails = () => import(/* webpackChunkName: "Coupon" */ '@/pages/Coupon/couponDetails');
const distributionVoucher = () => import(/* webpackChunkName: "Coupon" */ '@/pages/Coupon/distributionVoucher');
const distributionDetails = () => import(/* webpackChunkName: "Coupon" */ '@/pages/Coupon/distributionDetails');
//会员积分
const IntegralMall = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/IntegralMall');
const IntegralDetail = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/IntegralDetail');
const ExchangeRecords = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/ExchangeRecords');
const ExchangeItemDetails = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/ExchangeItemDetails');
const PointOrderDetails = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/PointOrderDetails');
const PointOrderWriteOff = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/PointOrderWriteOff');
const PointOrderWriteOffSuccess = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/success');
const VerifiyTradeRecord = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/VerifiyTradeRecord');




const MemberCenter = () => import(/* webpackChunkName: "Integral" */ '@/pages/Integral/MemberCenter');
// 家政服务
const houseHomePage = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/homePage');
const houseKeeping = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/index');
const myAppoint = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/myAppoint');
const myAppointDetail = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/myAppointDetail');
const appointForm = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/appointForm');
const houseDispatch = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/dispatch');
const costEvaluate = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/costEvaluate');
const serviceCompletion = () => import(/* webpackChunkName: "houseKeeping" */ '@/pages/houseKeeping/serviceCompletion');
// 办公耗材
const officeService = () => import(/* webpackChunkName: "officeService" */ '@/pages/officeService/index');
const officeServiceDetail = () => import(/* webpackChunkName: "officeService" */ '@/pages/officeService/details');
const officeConfirmOrder = () => import(/* webpackChunkName: "officeService" */ '@/pages/officeService/confirmOrder');
const officeDispatch = () => import(/* webpackChunkName: "officeService" */ '@/pages/officeService/dispatch');
const officeOrderDeliveryList = () => import(/* webpackChunkName: "officeService" */ '@/pages/officeService/officeOrderDeliveryList');
// 水电缴费明细页面
const billDetails = () => import(/* webpackChunkName: "comReporting" */ '@/pages/comReporting/billDetails');
// 公司月卡

const parkingCompanyPass = () => import(/* webpackChunkName: "parking" */ '@/pages/parkingCompanyPass/index');
const parkingCompanyAddPass = () => import(/* webpackChunkName: "parking" */ '@/pages/parkingCompanyPass/addPass');
const parkingCompanyApplyDetail = () => import(/* webpackChunkName: "parking" */ '@/pages/parkingCompanyPass/applyDetail');
const parkingCompanyxuqian = () => import(/* webpackChunkName: "parking" */ '@/pages/parkingCompanyPass/xuqian');

//停车
const parking = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/index');
const XuQian = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/xuqian');
const repeatApply = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/repeatApply');
const parkingAgreement = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/parkingAgreement');
const parkingService = () => import(/* webpackChunkName: "parkingService" */ '@/pages/parkingService/index');
const parkingPay = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/parkingPay');
const parkingPayRecord = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/parkingPayRecord');
const paymentRecordDetail = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/paymentRecordDetail');
const parkingApplyDetail = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/applyDetail');
const addCardNumber = () => import(/* webpackChunkName: "parking" */ '@/pages/parking/addCardNumber');
const parkingSearchSuccess = () => import(/* webpackChunkName: "parkingService" */ '@/pages/parkingService/components/parkingSearchSuccess');
const paySuccess = () => import(/* webpackChunkName: "parkingService" */ '@/pages/parkingService/components/paySuccess');
const kaizhaSuccess = () => import(/* webpackChunkName: "parkingService" */ '@/pages/parkingService/parkingScanDetail');
const kaizhaStatus = () => import(/* webpackChunkName: "parkingService" */ '@/pages/parkingService/kaizhaStatus');
const parkingDiscount = () =>
  import(/* webpackChunkName: "parking" */ "@/pages/parking/parkingDiscount");
const discountList = () =>import(/* webpackChunkName: "parking" */ "@/pages/parking/discountList");
const parkFeeList = () =>
  import(/* webpackChunkName: "parking" */ "@/pages/parking/parkFeeList");

// 停车券
const parkingCoupon = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/index');
const buyCoupon = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/buyCoupon');
const dispatchRecord = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/dispatchRecord');
const dispatchRecordDetail = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/dispatchRecordDetail');
const confirmOrder = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/confirmOrder');
const qrcodeDispatch = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/qrcodeDispatch');
const getParkingCoupon = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/getParkingCoupon');
const buyRecord = () => import(/* webpackChunkName: "parkingCoupon" */ '@/pages/parkingCoupon/buyRecord');
//预览
const yulanpdf = () => import(/* webpackChunkName: "yulan" */ '@/pages/yulan/pdf');
const yuelanImage = () => import(/* webpackChunkName: "yulan" */ '@/pages/yulan/image');
// 智慧办公
const SmartOffice = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/index/index');
const smartOfficeMeetingRoom = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/index');
const smartOfficeRoomDate = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/roomDate');
const smartOfficeRoomConfirm = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/roomConfirm');
const smartOfficeRoomSucc = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/appointSucc');
const smartOfficeMyAppoint = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/myAppoint');
const smartOfficeMyAppointDetail = () => import(/* webpackChunkName: "smartOffice" */ '@/pages/smartOffice/meetingRoom/myAppointDetail');
const EchartPie = () => import(/* webpackChunkName: "echarts" */ '@/pages/echarts_demo/EchartPie');
const EchartsLine = () => import(/* webpackChunkName: "echarts" */ '@/pages/echarts_demo/EchartLine');

const IframePage = () => import(/* webpackChunkName: "others" */ '@/pages/iframePage');
const SelectMarket = () => import(/* webpackChunkName: "others" */ '@/pages/home/selectMarket');
const Service = () => import(/* webpackChunkName: "others" */ '@/pages/Service');
const ViewImgs = () => import(/* webpackChunkName: "others" */ '@/pages/viewImgs');
const NotFound = () => import(/* webpackChunkName: "others" */ '@/components/notfound');


const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_APP_HOST ? "" : "/tch5/",
  fallback: true,
  routes: [
    {
      path: "/",
      redirect: "/home",
      component: () => import("../basic.vue"),
      children: [
        {
          path: "/home",
          name: "home",
          component: Home,
          meta: { title: "", index: 0, share: true },
        },
        {
          path: "/activity",
          name: "activity",
          component: Activity,
          meta: { title: "发现", index: 0 },
        },
        {
          path: "/me",
          name: "me",
          component: Me,
          meta: { title: "我的", index: 0 },
        },
        {
          path: "/smartOffice",
          name: "smartOffice",
          component: SmartOffice,
          meta: { title: "智慧办公", index: 0 },
        },
        {
          path: "/echarts_demo",
          name: "echarts",
          component: { render: (h) => h("router-view") },
          children: [
            {
              path: "/echarts_demo/pie",
              meta: { title: "饼图" },
              component: EchartPie,
            },
            {
              path: "/echarts_demo/line",
              meta: { title: "曲线图" },
              component: EchartsLine,
            },
          ],
        },
        {
          path: "/smartOffice/meetingRoom",
          name: "smartOfficeRoom",
          meta: { title: "会议室预订" },
          component: smartOfficeMeetingRoom,
        },
        {
          path: "/smartOffice/roomDate",
          name: "smartOfficeRoomDate",
          meta: { title: "预订信息" },
          component: smartOfficeRoomDate,
        },
        {
          path: "/smartOffice/roomConfirm",
          name: "smartOfficeRoomConfirm",
          meta: { title: "确认订单" },
          component: smartOfficeRoomConfirm,
        },
        {
          path: "/smartOffice/succ",
          name: "smartOfficeRoomSucc",
          meta: { title: "" },
          component: smartOfficeRoomSucc,
        },
        {
          path: "/smartOffice/meetingAppoint",
          name: "smartOfficeRoomAppoint",
          meta: { title: "我的订单" },
          component: smartOfficeMyAppoint,
        },
        {
          path: "/smartOffice/meetingAppointDetail",
          name: "smartOfficeRoomAppointDetail",
          meta: { title: "订单详情" },
          component: smartOfficeMyAppointDetail,
        },
        {
          path: "/me/Setting",
          name: "Setting",
          component: Setting,
          meta: { title: "账户设置" },
        },
        {
          path: "/me/EditName",
          name: "EditName",
          component: EditName,
          meta: { title: "修改昵称" },
        },
        {
          path: "/iframePage",
          name: "iframePage",
          component: IframePage,
          meta: { title: "" },
        },
        {
          path: "/selectMarket",
          name: "selectMarket",
          component: SelectMarket,
          meta: { title: "选择项目" },
        },
        {
          path: "/projectIntro",
          name: "projectIntroduction",
          component: ProjectIntroduction,
          meta: { title: "项目介绍", share: true },
        },
        {
          path: "/activityDetails/:id",
          name: "activityDetails",
          component: ActivityDetails,
          meta: { title: "活动详情", share: true },
        },
        {
          path: "/activityForm/:id",
          name: "activityForm",
          component: ActivityForm,
          meta: { title: "报名信息" },
        },
        {
          path: "/activityOrderInfo",
          name: "activityOrderInfo",
          component: ActivityOrderInfo,
          meta: { title: "确认活动订单" },
        },
        {
          path: "/activitySuccess",
          name: "activitySuccess",
          component: ActivitySuccess,
          meta: { title: "活动成功" },
        },
        {
          path: "/companyDetail/:id",
          name: "companyDetail",
          component: CompanyDetail,
          meta: { title: "企业详情", share: true },
        },
        {
          path: "/myOrder",
          name: "myOrder",
          component: MyOrder,
          meta: { title: "我的订单" },
        },
        {
          path: "/activityOrder",
          name: "activityOrderDetail",
          component: MyActivityOrder,
          meta: { title: "活动订单" },
        },
        {
          path: "/meetingOrder",
          name: "meetingOrderDetail",
          component: MyMeetingOrder,
          meta: { title: "会议室订单" },
        },
        {
          path: "/invoiceFrom",
          name: "invoiceFrom",
          component: InvoiceFrom,
          meta: { title: "开具发票" },
        },

        {
          path: "/myOfficeOrder",
          name: "myOfficeOrder",
          component: MyOfficeOrder,
          meta: { title: "办公耗材订单" },
        },
        {
          path: "/myOfficeWxOrder",
          name: "myOfficeWxOrder",
          component: MyOfficeWxOrder,
          meta: { title: "办公耗材订单" },
        },
        {
          path: "/login",
          name: "login",
          component: Login,
          meta: { title: "" },
        },
        {
          path: "/service",
          name: "service",
          component: Service,
          meta: {
            title: "服务协议",
          },
        },
        {
          path: "/viewImgs",
          name: "viewImgs",
          component: ViewImgs,
          meta: {
            title: "全部照片",
          },
        },
        {
          path: "/about",
          name: "about",
          component: About,
          meta: {
            title: "关于",
          },
        },
        {
          path: "/successPage",
          name: "successPage",
          component: SuccessPage,
          meta: { title: "" },
        },
        {
          path: "/agreeMent",
          name: "agreeMent",
          component: AgreeMent,
          meta: {
            title: "隐私政策",
          },
        },
        {
          path: "/companyList",
          name: "companyList",
          component: CompanyList,
          meta: {
            title: "企业认证",
            needLogin: true,
          },
        },
        {
          path: "/addCompany",
          name: "addCompany",
          component: AddCompany,
          meta: {
            title: "新增企业认证",
            needLogin: true,
          },
        },
        {
          path: "/companySelect",
          name: "companySelect",
          component: CompanySelect,
          meta: {
            title: "公司列表",
            needLogin: true,
          },
        },
        {
          path: "/addPhoto",
          name: "addPhoto",
          component: AddPhoto,
          meta: {
            title: "新增企业",
            needLogin: true,
            share: true,
          },
        },
        {
          path: "/shotPhoto",
          name: "shotPhoto",
          component: ShotPhoto,
          meta: {
            title: "拍摄",
            needLogin: true,
          },
        },

        {
          path: "/parkMemberList/:id",
          name: "parkMemberList",
          component: parkMemberList,
          meta: {
            title: "团队成员",
            index: 1,
          },
        },
        {
          path: "/noticeList",
          name: "noticeList",
          component: noticeList,
          meta: {
            title: "公告通知",
            index: 1,
          },
        },

        {
          path: "/noticeDetail/:id",
          name: "noticeDetail",
          component: noticeDetail,
          meta: {
            title: "公告详情",
            index: 1,
          },
        },
        {
          path: "/noticeFrom",
          name: "noticeFrom",
          component: noticeFrom,
          meta: {
            title: "留言",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/approvalList",
          name: "approvalList",
          component: ApprovalList,
          meta: {
            title: "审批",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/approvalDetail",
          name: "approvalDetail",
          component: ApprovalDetail,
          meta: {
            title: "处理审批",
            needLogin: true,
            index: 1,
          },
        },

        {
          path: "/VisitorReservationDetail/:id",
          name: "VisitorReservationDetail",
          component: VisitorReservationDetail,
          meta: {
            title: "处理审批",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/meetingApproval",
          name: "meetingApproval",
          component: MeetingApproval,
          meta: {
            title: "审批详情",
            needLogin: true,
          },
        },
        {
          path: "/officeApproval",
          name: "officeApproval",
          component: OfficeApproval,
          meta: {
            title: "办公耗材订单详情",
          },
        },
        {
          path: "/bill",
          name: "bill",
          component: Bill,
          meta: {
            title: "租赁账单",
            needLogin: true,
            index: 1,
          },
        },

        {
          path: "/billDetail",
          name: "billDetail",
          component: BillDetail,
          meta: {
            title: "账单详情",
            needLogin: true,
            index: 1,
            share: true,
          },
        },
        {
          path: "/billHistory",
          name: "billHistory",
          component: BillHistory,
          meta: {
            title: "全部账单",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/revenueIndex",
          name: "revenueIndex",
          component: RevenueIndex,
          meta: {
            title: "营收填报",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/revenueForm",
          name: "revenueForm",
          component: RevenueForm,
          meta: {
            title: "填写营报",
            needLogin: true,
            index: 1,
          },
        },

        {
          path: "/news",
          name: "news",
          component: News,
          meta: {
            title: "消息中心",
            index: 1,
          },
        },
        {
          path: "/fanke",
          name: "fanke",
          component: Fanke,
          meta: {
            title: "新建预约",
            index: 1,
          },
        },
        {
          path: "/BusinessLife",
          name: "BusinessLife",
          component: BusinessLife,
          meta: {
            title: "商业生活",
            index: 1,
          },
        },
        {
          path: "/BusinessSearch",
          name: "BusinessSearche",
          component: BusinessSearch,
          meta: {
            title: "商业生活",
            index: 1,
            share: true,
          },
        },
        {
          path: "/BusinessDetail/:id",
          name: "BusinessDetail",
          component: BusinessDetail,
          meta: {
            title: "商铺详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/searchPerson",
          name: "searchPerson",
          component: searchPerson,
          meta: {
            title: "选择信息",
            index: 1,
          },
        },
        {
          path: "/searchCompany",
          name: "searchCompany",
          component: searchCompany,
          meta: {
            title: "公司列表",
            index: 1,
          },
        },

        {
          path: "/visitAccessCard/:id",
          name: "visitAccessCard",
          component: VisitAccessCard,
          meta: {
            title: "拜访门禁卡",
          },
        },
        {
          path: "/visitHistory",
          name: "visitHistory",
          component: VisitHistory,
          meta: {
            title: "历史预约",
            index: 1,
          },
        },
        {
          path: "/visitDetails",
          name: "visitDetails",
          component: VisitDetails,
          meta: {
            title: "预约详情",
            index: 1,
          },
        },
        {
          path: "/accessControl",
          name: "accessControl",
          component: AccessControl,
          meta: {
            title: "智慧通行",
            index: 1,
          },
        },

        {
          path: "/InvoicIndex",
          name: "InvoicIndex",
          component: InvoicIndex,
          meta: {
            title: "开具发票",
            index: 1,
          },
        },
        {
          path: "/InvoicingList",
          name: "InvoicingList",
          component: InvoicingList,
          meta: {
            title: "可开票列表",
            index: 1,
          },
        },
        {
          path: "/invoiceHistory",
          name: "invoiceHistory",
          component: invoiceHistory,
          meta: {
            title: "开票历史",
            index: 1,
          },
        },
        {
          path: "/invoiceDetail",
          name: "invoiceDetail",
          component: invoiceDetail,
          meta: {
            title: "发票详情",
            index: 1,
          },
        },
        {
          path: "/invoiceInfo",
          name: "invoiceInfo",
          component: invoiceInfo,
          meta: {
            title: "发票订单信息",
            index: 1,
          },
        },
        {
          path: "/invoiceDetailRepeat",
          name: "invoiceDetailRepeat",
          component: invoiceDetailRepeat,
          meta: {
            title: "重发电子发票",
            index: 1,
          },
        },
        {
          path: "/invoiceFromPage",
          name: "invoiceFromPage",
          component: invoiceFromPage,
          meta: {
            title: "开具发票",
            index: 1,
          },
        },
        {
          path: "/InvoicSuccess",
          name: "InvoicSuccess",
          component: InvoicSuccess,
          meta: {
            title: "",
            index: 1,
          },
        },

        {
          path: "/invoiceHelp",
          name: "invoiceHelp",
          component: invoiceHelp,
          meta: {
            title: "开票帮助",
            index: 1,
          },
        },

        {
          path: "/hpRecharge",
          name: "hpRecharge",
          component: hpRecharge,
          meta: {
            title: "电费充值",
            index: 1,
          },
        },
        {
          path: "/rechargeRecord",
          name: "rechargeRecord",
          component: rechargeRecord,
          meta: {
            title: "充值记录",
            index: 1,
          },
        },
        {
          path: "/hpuseStatistics",
          name: "hpuseStatistics",
          component: hpuseStatistics,
          meta: {
            title: "用电统计",
            index: 1,
          },
        },
        {
          path: "/hpuseDetailed",
          name: "hpuseDetailed",
          component: hpuseDetailed,
          meta: {
            title: "用电明细",
            index: 1,
          },
        },
        {
          path: "/meetingRoom",
          name: "meetingRoom",
          component: MeetingRoom,
          meta: {
            title: "会议室预订",
            index: 1,
          },
        },
        {
          path: "/roomDetail",
          name: "roomDetail",
          component: RoomDetail,
          meta: {
            title: "会议室详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/roomDate/:id",
          name: "roomDate",
          component: RoomDate,
          meta: {
            title: "选择预订时段",
            index: 1,
          },
        },
        {
          path: "/roomPay",
          name: "roomPay",
          component: RoomPay,
          meta: {
            title: "确认订单",
            index: 1,
          },
        },

        {
          path: "/WaterMeetingIndex",
          name: "WaterMeetingIndex",
          component: WaterMeetingIndex,
          meta: {
            title: "会议室水牌首页",
            index: 1,
          },
        },
        {
          path: "/WaterMeetingMian",
          name: "WaterMeetingMian",
          component: WaterMeetingMian,
          meta: {
            title: "会议室水牌",
            index: 1,
          },
        },

        {
          path: "/WaterSignIndex",
          name: "WaterSignIndex",
          component: WaterSignIndex,
          meta: {
            title: "会议室水牌首页",
            index: 1,
          },
        },
        {
          path: "/WaterSignMian",
          name: "WaterSignMian",
          component: WaterSignMian,
          meta: {
            title: "会议室水牌",
            index: 1,
          },
        },

        {
          path: "/smartOffice/StruggleReport",
          name: "StruggleReport",
          component: StruggleReport,
          meta: {
            title: "奋斗报告",
            index: 0,
          },
        },
        {
          path: "/smartOffice/StruggleCalendar",
          name: "StruggleCalendar",
          component: StruggleCalendar,
          meta: {
            title: "奋斗报告",
            index: 0,
          },
        },
        {
          path: "/smartOffice/StruggleMonthlyReport",
          name: "StruggleMonthlyReport",
          component: StruggleMonthlyReport,
          meta: {
            title: "奋斗报告",
            index: 0,
          },
        },
        {
          path: "/smartOffice/StruggleSignInList",
          name: "StruggleSignInList",
          component: StruggleSignInList,
          meta: {
            title: "打卡明细",
            index: 1,
          },
        },
        {
          path: "/smartOffice/environmental",
          name: "environmental",
          component: Environmental,
          meta: {
            title: "环境指数",
            index: 1,
          },
        },
        {
          path: "/smartOffice/energyConsumption",
          name: "energyConsumption",
          component: EnergyConsumption,
          meta: {
            title: "能耗曲线",
            index: 1,
          },
        },

        {
          path: "/yudingName",
          name: "yudingName",
          component: YudingName,
          meta: {
            title: "预订人信息",
            index: 1,
          },
        },
        {
          path: "/evaluate/evaluate",
          name: "evaluate",
          component: evaluate,
          meta: {
            title: "评价",
            index: 1,
          },
        },
        {
          path: "/evaluate/evaluateSm",
          name: "evaluateSm",
          component: evaluateSm,
          meta: {
            title: "评价",
            index: 1,
          },
        },
        {
          path: "/evaluate/viewEvaluate",
          name: "viewEvaluate",
          component: viewEvaluate,
          meta: {
            title: "查看评价",
            index: 1,
          },
        },
        {
          path: "/evaluateSuccess",
          name: "evaluateSuccess",
          component: evaluateSuccess,
          meta: {
            title: "评价成功",
            index: 1,
          },
        },
        {
          path: "/comReporting",
          name: "comReporting",
          component: comReporting,
          meta: {
            title: "选择合同",
            index: 1,
          },
        },
        {
          path: "/comReportingDetails",
          name: "comReportingDetails",
          component: comReportingDetails,
          meta: {
            title: "企业报表",
            index: 1,
            share: true,
          },
        },
        {
          path: "/emptyShopList",
          name: "emptyShopList",
          component: EmptyShopList,
          meta: {
            title: "空铺招租",
            index: 1,
          },
        },
        {
          path: "/emptyShopDetail",
          name: "emptyShopDetail",
          component: EmptyShopDetail,
          meta: {
            title: "空铺详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/wuyeRepair",
          name: "wuyeRepair",
          component: WuyeRepair,
          meta: {
            title: "物业报修",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/sublimeSuccess",
          name: "sublimeSuccess",
          component: SublimeSuccess,
          meta: {
            title: "",
            index: 1,
          },
        },
        {
          path: "/myRepairOrder",
          name: "myRepairOrder",
          component: MyRepairOrder,
          meta: {
            title: "我的报修",
            needLogin: true,
            index: 1,
          },
        },
        {
          path: "/repairOrderDetails",
          name: "repairOrderDetails",
          component: RepairOrderDetails,
          meta: {
            title: "报修详情",
            index: 1,
          },
        },
        {
          path: "/viewVideo",
          name: "viewVideo",
          component: ViewVideo,
          meta: {
            title: "查看视频",
            index: 1,
          },
        },
        {
          path: "/viewImage",
          name: "viewImage",
          component: ViewImage,
          meta: {
            title: "查看图片",
            index: 1,
          },
        },
        {
          path: "/policyServices",
          name: "policyServices",
          component: policyServices,
          meta: {
            title: "政策服务",
            index: 1,
          },
        },
        {
          path: "/policySearch",
          name: "policySearch",
          component: policySearch,
          meta: {
            title: "政策搜索",
            index: 1,
          },
        },
        {
          path: "/policyDetail",
          name: "policyDetail",
          component: policyDetail,
          meta: {
            title: "政策详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/comsultationForm/:typeId/:id",
          name: "comsultationForm",
          component: comsultationForm,
          meta: {
            title: "咨询",
            index: 1,
          },
        },
        {
          path: "/policyList",
          name: "policyList",
          component: policyList,
          meta: {
            title: "政策列表",
            index: 1,
          },
        },
        {
          path: "/fileList",
          name: "fileList",
          component: fileList,
          meta: {
            title: "附件",
            index: 1,
          },
        },
        {
          path: "/myConsultation",
          name: "myConsultation",
          component: myConsultation,
          meta: {
            title: "我的咨询",
            index: 1,
          },
        },
        {
          path: "/myConsultationDetail",
          name: "myConsultationDetail",
          component: myConsultationDetail,
          meta: {
            title: "咨询详情",
            index: 1,
          },
        },
        {
          path: "/handleConsultation",
          name: "handleConsultation",
          component: handleConsultation,
          meta: {
            title: "咨询详情",
            index: 1,
          },
        },
        {
          path: "/allModule",
          name: "allModule",
          component: allModule,
          meta: {
            title: "全部应用",
            index: 1,
          },
        },
        {
          path: "/editAllModule",
          name: "editAllModule",
          component: editAllModule,
          meta: {
            title: "调整顺序",
            index: 1,
          },
        },
        {
          path: "/houseKeeping",
          name: "houseKeeping",
          component: houseKeeping,
          meta: {
            title: "家政服务",
            index: 1,
          },
        },
        {
          path: "/houseHomePage",
          name: "houseHomePage",
          component: houseHomePage,
          meta: {
            title: "家政服务",
            index: 1,
          },
        },
        {
          path: "/myAppoint",
          name: "myAppoint",
          component: myAppoint,
          meta: {
            title: "我的预约",
            index: 1,
          },
        },
        {
          path: "/myAppointDetail",
          name: "myAppointDetail",
          component: myAppointDetail,
          meta: {
            title: "服务单详情",
            index: 1,
          },
        },
        {
          path: "/appointForm",
          name: "appointForm",
          component: appointForm,
          meta: {
            title: "预约服务",
            index: 1,
          },
        },
        {
          path: "/houseDispatch",
          name: "houseDispatch",
          component: houseDispatch,
          meta: {
            //title: "派单",
            title: "",
            index: 1,
          },
        },
        {
          path: "/officeDispatch",
          name: "officeDispatch",
          component: officeDispatch,
          meta: {
            title: "派单",
            index: 1,
          },
        },
        {
          path: "/deliveryList",
          name: "officeOrderDeliveryList",
          component: officeOrderDeliveryList,
          meta: {
            title: "送货单",
            index: 1,
          },
        },
        {
          path: "/costEvaluate",
          name: "costEvaluate",
          component: costEvaluate,
          meta: {
            title: "费用评估",
            index: 1,
          },
        },
        {
          path: "/serviceCompletion",
          name: "serviceCompletion",
          component: serviceCompletion,
          meta: {
            title: "服务完成",
            index: 1,
          },
        },
        {
          path: "/tsComplaint",
          name: "tsComplaint",
          component: tsComplaint,
          meta: {
            title: "投诉建议",
            index: 1,
          },
        },
        {
          path: "/myComplaintOrder",
          name: "myComplaintOrder",
          component: myComplaintOrder,
          meta: {
            title: "我的投诉",
            index: 1,
          },
        },
        {
          path: "/repairComplaintDetails",
          name: "repairComplaintDetails",
          component: repairComplaintDetails,
          meta: {
            title: "投诉详情",
            index: 1,
          },
        },
        //优惠券
        {
          path: "/myCoupon",
          name: "myCoupon",
          component: myCoupon,
          meta: {
            title: "我的卡券",
            index: 1,
          },
        },
        {
          path: "/couponDetails/:id",
          name: "couponDetails",
          component: couponDetails,
          meta: {
            title: "我的卡券",
            index: 1,
          },
        },
        {
          path: "/distributionVoucher",
          name: "distributionVoucher",
          component: distributionVoucher,
          meta: {
            title: "领券中心",
            index: 1,
          },
        },
        {
          path: "/distributionDetails/:id",
          name: "distributionDetails",
          component: distributionDetails,
          meta: {
            title: "领券中心",
            index: 1,
          },
        },
        {
          path: "/IntegralMall",
          name: "IntegralMall",
          component: IntegralMall,
          meta: {
            title: "积分商城",
            index: 1,
          },
        },
        {
          path: "/IntegralDetail",
          name: "IntegralDetail",
          component: IntegralDetail,
          meta: {
            title: "积分明细",
            index: 1,
          },
        },
        {
          path: "/ExchangeRecords",
          name: "ExchangeRecords",
          component: ExchangeRecords,
          meta: {
            title: "我的兑换",
            index: 1,
          },
        },
        {
          path: "/ExchangeItemDetails",
          name: "ExchangeItemDetails",
          component: ExchangeItemDetails,
          meta: {
            title: "商品详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/PointOrderWriteOff",
          name: "PointOrderWriteOff",
          component: PointOrderWriteOff,
          meta: {
            title: "订单核销",
            index: 1,
          },
        },
        {
          path: "/VerifiyTradeRecord",
          name: "VerifiyTradeRecord",
          component: VerifiyTradeRecord,
          meta: {
            title: "商户核销",
            index: 1,
          },
        },
        
        {
          path: "/PointOrderWriteOffSuccess",
          name: "PointOrderWriteOffSuccess",
          component: PointOrderWriteOffSuccess,
          meta: {
            title: "订单核销",
            index: 1,
          },
        },

        

        {
          path: "/PointOrderDetails",
          name: "PointOrderDetails",
          component: PointOrderDetails,
          meta: {
            title: "订单详情",
            index: 1,
          },
        },
        {
          path: "/MemberCenter",
          name: "MemberCenter",
          component: MemberCenter,
          meta: {
            title: "会员中心",
            index: 1,
          },
        },
       
         {
          path: "/CompanyParkingPass",
          name: "parkingCompanyPass",
          component:  parkingCompanyPass,
          meta: {
            title: "公司月卡",
            index: 1,
          },
        },
        {
          path: "/CompanyParkingAddPass",
          name: "parkingCompanyAddPass",
          component:  parkingCompanyAddPass,
          meta: {
            title: "新增公司月卡",
            index: 1,
          },
        },
        {
          path: "/parkingCompanyApplyDetail",
          name: "parkingCompanyApplyDetail",
          component:  parkingCompanyApplyDetail,
          meta: {
            title: "公司月卡",
            index: 1,
          },
        },
        {
          path: "/parkingCompanyxuqian",
          name: "parkingCompanyxuqian",
          component:  parkingCompanyxuqian,
          meta: {
            title: "公司月卡续签",
            index: 1,
          },
        },

        
        
        

        {
          path: "/parking",
          name: "parking",
          component: parking,
          meta: {
            title: "停车月卡",
            index: 1,
          },
        },
        {
          path: "/xuQian",
          name: "xuQian",
          component: XuQian,
          meta: { title: "停车月卡" },
        },
        {
          path: "/repeatApply",
          name: "repeatApply",
          component: repeatApply,
          meta: { title: "停车月卡" },
        },
        {
          path: "/parkingAgreement",
          name: "parkingAgreement",
          component: parkingAgreement,
          meta: { title: "预览合同" },
        },
        {
          path: "/parkingService",
          name: "parkingService",
          component: parkingService,
          meta: { title: "停车缴费" },
        },
        {
          path: "/parkingSearchSuccess",
          name: "parkingSearchSuccess",
          component: parkingSearchSuccess,
          meta: { title: "查询结果" },
        },
        {
          path: "/paySuccess",
          name: "paySuccess",
          component: paySuccess,
          meta: { title: "" },
        },
        {
          path: "/parkingPay",
          name: "parkingPay",
          component: parkingPay,
          meta: { title: "月卡缴费" },
        },
        {
          path: "/parkingPayRecord",
          name: "parkingPayRecord",
          component: parkingPayRecord,
          meta: { title: "缴费记录" },
        },
        {
          path: "/paymentRecordDetail",
          name: "paymentRecordDetail",
          component: paymentRecordDetail,
          meta: { title: "缴费详情" },
        },
        {
          path: "/parkingApplyDetail",
          name: "parkingApplyDetail",
          component: parkingApplyDetail,
          meta: {},
        },
        {
          path: "/addCardNumber",
          name: "addCardNumber",
          component: addCardNumber,
          meta: { title: "添加车牌" },
        },
        {
          path: "/parkingScanDetail/:parkCode/:channelSeq/:entranceType",
          name: "parkingScanDetail",
          component: kaizhaSuccess,
          meta: { title: "停车缴费" },
        },
        {
          path: "/kaizhaStatus",
          name: "kaizhaStatus",
          component: kaizhaStatus,
          meta: { title: "停车缴费" },
        },
        {
          path: "/parkingDiscount",
          name: "parkingDiscount",
          component: parkingDiscount,
          meta: { title: "申请临停优惠" },
        },

        {
          path: "/discountList",
          name: "discountList",
          component: discountList,
          meta: { title: "申请临停优惠" },
        },
        {
          path: "/parkFeeList",
          name: "parkFeeList",
          component: parkFeeList,
          meta: { title: "停车月卡" },
        },

        {
          path: "/billDetails",
          name: "billDetails",
          component: billDetails,
          meta: {
            title: "用电明细",
            index: 1,
          },
        },
        {
          path: "/yulanpdf",
          name: "yulanpdf",
          component: yulanpdf,
          meta: {
            title: "预览",
            index: 1,
          },
        },
        {
          path: "/yuelanImage",
          name: "yuelanImage",
          component: yuelanImage,
          meta: {
            title: "预览",
            index: 1,
          },
        },

        {
          path: "/officeService",
          name: "officeService",
          component: officeService,
          meta: {
            title: "办公耗材",
            index: 1,
          },
        },
        {
          path: "/officeServiceDetail",
          name: "officeServiceDetail",
          component: officeServiceDetail,
          meta: {
            title: "办公耗材详情",
            index: 1,
            share: true,
          },
        },
        {
          path: "/officeConfirmOrder",
          name: "officeConfirmOrder",
          component: officeConfirmOrder,
          meta: {
            title: "确认订单",
            index: 1,
          },
        },
        {
          path: "/parkingCoupon",
          name: "parkingCoupon",
          component: parkingCoupon,
          meta: { title: "停车券" },
        },
        {
          path: "/buyRecord",
          name: "buyRecord",
          component: buyRecord,
          meta: { title: "购买记录" },
        },
        {
          path: "/buyCoupon",
          name: "buyCoupon",
          component: buyCoupon,
          meta: { title: "购券" },
        },
        {
          path: "/dispatchRecord",
          name: "dispatchRecord",
          component: dispatchRecord,
          meta: { title: "派券记录" },
        },
        {
          path: "/dispatchRecordDetail",
          name: "dispatchRecordDetail",
          component: dispatchRecordDetail,
          meta: { title: "使用记录" },
        },
        {
          path: "/confirmOrder",
          name: "confirmOrder",
          component: confirmOrder,
          meta: { title: "确认订单" },
        },
        {
          path: "/qrcodeDispatch",
          name: "qrcodeDispatch",
          component: qrcodeDispatch,
          meta: { title: "二维码派券" },
        },
        {
          path: "/getParkingCoupon",
          name: "getParkingCoupon",
          component: getParkingCoupon,
          meta: { title: "领取停车券" },
        },
      ],
    },
    {
      path: "*",
      name: "notfound",
      component: NotFound,
      meta: {
        title: "404",
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      // if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop;
      // }
      return {
        x: 0,
        y: to.meta.savedPosition || 0,
      };
    }
  },
});
router.beforeEach((to, from, next) => {
  next()
})
export default router;
